import { Common } from './common';
import {
  CreateOptions,
  DashboardEmbedPopulated,
  UpdateOptions,
} from './models/dashboard/dashboardEmbed';
import * as DashboardTemplate from './models/dashboard/dashboardTemplate';

interface FindAllOptions {
  organizationId?: string;
  standard?: boolean;
  page?: number;
  limit?: number;
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<DashboardEmbedPopulated[]> {
    const url = this.common.constructPath(`/dashboard-embeds`, options);
    return this.common.getJSON(url);
  }

  getProxyUrl(id: string): string {
    return this.common.constructPath(`/dashboard-embeds/${id}/proxy`);
  }

  async findOneById(id: string): Promise<DashboardEmbedPopulated> {
    const url = this.common.constructPath(`/dashboard-embeds/${id}`);
    return this.common.getJSON(url);
  }

  async removeOneById(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/dashboard-embeds/${id}`);
    return this.common.deleteJSON(url);
  }

  async findAllTemplates(): Promise<DashboardTemplate.DashboardTemplate[]> {
    const url = this.common.constructPath(`/dashboard-embeds/templates`);
    return this.common.getJSON(url);
  }

  async create(options: CreateOptions): Promise<DashboardEmbedPopulated> {
    const url = this.common.constructPath(`/dashboard-embeds`);
    return this.common.postJSON(url, options);
  }

  async update(
    id: string,
    options: UpdateOptions,
  ): Promise<DashboardEmbedPopulated> {
    const url = this.common.constructPath(`/dashboard-embeds/${id}`);
    return this.common.patchJSON(url, options);
  }
}
